import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Translation files
import en from "./locales/en.json";
import ka from "./locales/ka.json";
import ukr from "./locales/ukr.json";
import spa from "./locales/spa.json";
import ita from "./locales/ita.json";
import ger from "./locales/ger.json";
import fra from "./locales/fra.json";

const savedLanguage = localStorage.getItem("language");

// i18n initialization
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ka: { translation: ka },
    ukr: { translation: ukr },
    spa: { translation: spa },
    ita: { translation: ita },
    ger: { translation: ger },
    fra: { translation: fra },
  },
  lng: savedLanguage, // Default language
  fallbackLng: "en", // Fallback language if translation is missing
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ["localStorage"],
    caches: ["localStorage"],
  },
});

export default i18n;
